import React from 'react';
import moment from 'moment';
import AInput from '../../../../../views/pages/manage/common/formFeilds/customInput/AInput';
import styles from "../styles.module.scss";
import CustomDatePickerV2 from '../../../../../views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { regex } from '../../../../../views/pages/manage/common/constant';
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import { Tooltip } from '@mui/material';

const BatchStartDateLabel = ({ showValidationsTooltip }) => {

    const BatchStartDateValidations = () => {
        return (
            <div>
                <div>a. It should not be beyond (-) 30 days from the Course Start Date.</div>
                <div>b. It should not be lower than the "Minimum Receipt Date".</div>
                <div>c. The date cannot be earlier than the first installment payment date (if the first installment is already paid).</div>
            </div>
        )
    }
    return (
        <div>
            Batch Start Date
            {showValidationsTooltip &&
                <Tooltip
                    title={<BatchStartDateValidations />}
                    placement='top'
                >
                    <span className='ml-1'><InfoIconSolid color="black" /></span>
                </Tooltip>
            }
        </div>
    )
}

const inputStyles = { height: '40px', borderRadius: '4px' };

const RefundDetailsForm = ({
    form,
    studentDetails,
    // setPayableRefundInfo,
    // setLoading,
    // setForm,
    handleForm,
    viewOnly,
    studentLoanDetails,
    coursePricingDetails,
    forRefundEdit,
    getRefundInfoClickHandler,
    bypassValidationsForRole,
    buTypeName,
    isDLPCase,
    isFranchiseBuType
}) => {

    const isSubContractorBU = buTypeName?.toLowerCase() === "subcontractor";

    const { courseStartDate } = coursePricingDetails;
    const { registrationDate, studentFeeBreakup } = studentDetails;

    const {isLoanCase , netLoanAmount} = studentLoanDetails;

    const allNecessaryFieldsNotEntered = () => {
        const { refundApplicationDate, batchStartDate, batchEndDate, loanOutstanding, preClosureReferenceNumber, preClosureReferenceDate } = form;
        return (
            !refundApplicationDate ||
            (!isDLPCase && (!batchStartDate || !batchEndDate)) ||
            isLoanCase && (!loanOutstanding || !preClosureReferenceDate || !preClosureReferenceNumber)
        )
    }

    const getBatchStartMinDate = () => {

        const oneMonthBeforeCourseStart = moment(courseStartDate).subtract(1, "month");

        const dates = [oneMonthBeforeCourseStart];

        if (registrationDate) {
            dates.push(moment(registrationDate));
        }
        
        const firstInstallmentDetails = studentFeeBreakup?.feeSummaryDTOList?.find(el => el?.minimumItemType?.slice(-4, -2) === '01');
        const firstInstallmentPaymentDate = firstInstallmentDetails?.status === "Paid" && firstInstallmentDetails?.dateOfPayment;

        if (firstInstallmentPaymentDate) {
            dates.push(moment(firstInstallmentPaymentDate));
        }

        return moment.max(dates).toDate();
    };


    const refundCreationDate = forRefundEdit ? form?.refundCreationDate : new Date();

    const batchStartMinDateValidationsApplicable = !isFranchiseBuType && !bypassValidationsForRole 
    
    const disableFormFields = viewOnly;

    return (
        <div className='a-card m-0'>
            <h3>Refund Details</h3>

            <div className={styles['refund-details-form']}>

                <div>
                    <CustomDatePickerV2
                        label={"Refund Application Date"}
                        value={form?.refundApplicationDate}
                        placeHolder="Select Refund Application Date"
                        handler={(index, date) => {
                            handleForm("refundApplicationDate", date);
                        }}
                        minDate={!isFranchiseBuType && !isSubContractorBU && !bypassValidationsForRole && moment(refundCreationDate).subtract(1, "month").toDate()}
                        maxDate={!isFranchiseBuType && !bypassValidationsForRole && refundCreationDate}
                        disabled={disableFormFields}
                    />
                </div>

                {!isDLPCase &&
                    <>
                        <div>
                            <CustomDatePickerV2
                                label={<BatchStartDateLabel showValidationsTooltip={batchStartMinDateValidationsApplicable}/>}
                                value={form?.batchStartDate}
                                handler={(index, date) => {
                                    handleForm("batchStartDate", date);
                                }}
                                placeHolder={"Select Batch Start Date"}

                                minDate={batchStartMinDateValidationsApplicable && getBatchStartMinDate()}
                                // maxDate={moment(courseStartDate).add(1, "month").toDate()}
                                disabled={disableFormFields}
                            />
                        </div>

                        <div>
                            <CustomDatePickerV2
                                label={"Batch End Date"}
                                value={form?.batchEndDate}
                                handler={(index, date) => {
                                    handleForm("batchEndDate", date);
                                }}
                                disabled
                            />
                        </div>
                    </>
                 } 

                {
                    isLoanCase &&
                    <>
                        <div>
                            <AInput
                                label="Pre-closure letter ref no."
                                value={form?.preClosureReferenceNumber}
                                handler={(val) => {
                                    handleForm("preClosureReferenceNumber", val);
                                }}
                                style={inputStyles}
                                placeholder={"Enter"}
                                regex={regex.alphaNumericWithSpaceAndUnderscore}
                                disabled={disableFormFields}
                            />
                        </div>

                        <div>
                            <CustomDatePickerV2
                                label={"Pre-closure letter ref no. date"}
                                value={form?.preClosureReferenceDate}
                                handler={(index, date) => {
                                    handleForm("preClosureReferenceDate", date);
                                }}
                                placeHolder={"Select Pre-closure letter ref no. date"}
                                disabled={disableFormFields}
                                maxDate={refundCreationDate}
                            />
                        </div>

                        <div>
                            <AInput
                                label="Loan O/S as per pre-closure letter"
                                value={form?.loanOutstanding}
                                handler={(val) => {
                                    if(val > netLoanAmount) return;
                                    handleForm("loanOutstanding", val);
                                }}
                                style={inputStyles}
                                placeholder="Enter"
                                regex={regex.numericDecimal}
                                disabled={disableFormFields}
                            />
                        </div>


                    </>
                }

                {!viewOnly &&
                    <AButton
                        variant='primary_filled'
                        // onClick={() => getRefundInfoClickHandler({ setPayableRefundInfo, setLoading, studentDetails, refundDetailsForm: form, handleRefundDetailsForm: handleForm })}
                        onClick={getRefundInfoClickHandler}
                        disabled={allNecessaryFieldsNotEntered()}
                        updatedStyle={{ marginTop: '1.75rem' }}
                        className='no-ml-btn'
                    >
                        Get Refund Info
                    </AButton>
                }

            </div>



        </div>
    );
}

export default RefundDetailsForm;